import { TechStackRefDto } from 'src/portal/buyerscaddy-api/models/tech-stack-ref-dto';

const TECH_EDITOR_PATHS = new Set(['/tech-editor', '/tech-editor-v2']);

export function buildTechEditorCompanySwitchUrl(
  currentUrl: string,
  companyId: string
): string | null {
  const normalizedCompanyId = companyId?.trim();
  if (!normalizedCompanyId) return null;

  const [urlWithoutFragment, fragment] = (currentUrl || '').split('#', 2);
  const queryIndex = urlWithoutFragment.indexOf('?');
  const rawPath = queryIndex >= 0
    ? urlWithoutFragment.slice(0, queryIndex)
    : urlWithoutFragment;
  const path = rawPath.split(';', 1)[0].replace(/\/+$/, '') || '/';

  if (!TECH_EDITOR_PATHS.has(path)) return null;

  const rawQuery = queryIndex >= 0
    ? urlWithoutFragment.slice(queryIndex + 1)
    : '';
  const query = new URLSearchParams(rawQuery);

  query.set('companyId', normalizedCompanyId);
  query.delete('techStackId');

  const queryString = query.toString();
  const fragmentSuffix = fragment ? `#${fragment}` : '';

  return `${path}${queryString ? `?${queryString}` : ''}${fragmentSuffix}`;
}

export function resolveTechStackSelection(
  stacks: TechStackRefDto[],
  techStackId?: string | null,
  techStackType?: string | null
): TechStackRefDto | undefined {
  const byId = techStackId
    ? stacks.find((stack) => stack.id === techStackId)
    : undefined;

  if (byId) return byId;

  return techStackType
    ? stacks.find((stack) => (stack.templateId || stack.type) === techStackType)
    : undefined;
}
